import React from 'react';
import style from './typeMembersTable.scss';
import {
  getMembers,
  getTypeDisplayName,
} from '../../../TypeDetails/NestedTable/utils';
import { NestedTable } from '../../../TypeDetails/NestedTable';
import { Rectangle } from '../../Rectangle/Rectangle';
import classnames from 'classnames';
import { Text } from '../../Text';
import { extractType } from '../../../TypeDetails/utils';
import { StoreContext } from '../../../../appContext/StoreProvider';
import { LegacySingleType, Type } from '../../../TypeDetails/typeParser';

const TypeTab = ({ isSelected, children, onClick }) => (
  <Rectangle
    className={classnames({
      [style.typeTab]: true,
      [style.notActive]: !isSelected,
    })}
    onClick={onClick}
  >
    {/*
// @ts-ignore TODO */}
    <Text size="small" weight="normal" link={!isSelected}>
      {children}
    </Text>
  </Rectangle>
);

interface TypeMembersTableProps {
  type: (Type | LegacySingleType)[];
  prefix: string;
  pageName: string;
  isResponse?: boolean; // we need this for the nested table that for response presentation
  JSLayoutType?: boolean;
}

export const TypeMembersTable = ({
  type,
  prefix,
  pageName,
  isResponse,
  JSLayoutType,
}: TypeMembersTableProps) => {
  const { store } = React.useContext(StoreContext);
  const [currentTypeIndex, setCurrentTypeIndex] = React.useState(0);
  const hasMultipleTypes = Array.isArray(type) && type.length > 1;
  const returnObject = Array.isArray(type)
    ? getMembers(store)(type[currentTypeIndex])
    : getMembers(store)(type);

  return (
    <React.Fragment>
      {hasMultipleTypes && (
        <div className={style.typeTabs} data-hook="type-tabs">
          {type.map((currentType, i) => (
            <React.Fragment key={i}>
              <TypeTab
                isSelected={i === currentTypeIndex}
                onClick={() => setCurrentTypeIndex(i)}
              >
                {getTypeDisplayName({
                  type: extractType(currentType),
                  store,
                  JSLayoutType,
                })}
              </TypeTab>
            </React.Fragment>
          ))}
        </div>
      )}
      <NestedTable
        tableDepth={0}
        params={returnObject.members}
        prefix={prefix}
        pageName={pageName}
        isResponse={isResponse}
        JSLayoutType={JSLayoutType}
      />
    </React.Fragment>
  );
};
